import styled from 'styled-components';
var Container = styled.span.withConfig({
  displayName: "Container",
  componentId: "a79x77-0"
})(["align-items:center;display:flex;flex-flow:row nowrap;justify-content:center;"]);
export default Container;